import { toast } from "react-hot-toast";

import { ApiService, LISCase } from "pwapi";

import { LIS } from "shared/actions/constants";
import { AsyncSagaAction, createAsyncSaga } from "shared/utils/asyncActions";

type GetArgs = Parameters<typeof ApiService.caseWithWorkBlock>[0];
export const getCaseForBlock = createAsyncSaga(
  LIS.BLOCK.GET_CASE.REQUEST,
  LIS.BLOCK.GET_CASE.SUCCESS,
  LIS.BLOCK.GET_CASE.ERROR,
  (args: GetArgs) => `lis/blocks/${args.id}/case`,
  (args: GetArgs) => ApiService.caseWithWorkBlock(args)
) as AsyncSagaAction<GetArgs>;

type ScanBlockArgs = Parameters<typeof ApiService.scanBlock>[0];
export const scanBlock = createAsyncSaga(
  LIS.BLOCK.SCAN.REQUEST,
  LIS.BLOCK.SCAN.SUCCESS,
  LIS.BLOCK.SCAN.ERROR,
  ({ id }) => `lis/blocks/${id}/scan`,
  (args: ScanBlockArgs) => {
    const tid = toast.loading("Scanned Block");
    return ApiService.scanBlock(args)
      .then((response: LISCase) => {
        toast.success("Scanned Block", { id: tid });
        return response;
      })
      .catch((error) => {
        toast.error(`Scanned Block\n${error.message}`, { id: tid });
      });
  }
) as AsyncSagaAction<ScanBlockArgs>;

export const printBlock = createAsyncSaga(
  LIS.BLOCK.PRINT.REQUEST,
  LIS.BLOCK.PRINT.SUCCESS,
  LIS.BLOCK.PRINT.ERROR,
  ({ id }) => `lis/blocks/${id}/print`,
  ApiService.printBlock
) as AsyncSagaAction<Parameters<typeof ApiService.printBlock>[0]>;

export const printBlocksToCassettePrinterAsync = createAsyncSaga(
  LIS.BLOCK.PRINT_CASSETTES.REQUEST,
  LIS.BLOCK.PRINT_CASSETTES.REQUEST_SUCCESS,
  LIS.BLOCK.PRINT_CASSETTES.REQUEST_ERROR,
  ({ requestBody }) => `blocks/print-async/${requestBody.block_ids.join(",")}`,
  ApiService.printCassettesBlock
) as AsyncSagaAction<Parameters<typeof ApiService.printCassettesBlock>[0]>;

type UpdateBlockArgs = Parameters<typeof ApiService.partialUpdateAdminBlock>[0];
export const updateBlock = createAsyncSaga(
  LIS.BLOCK.UPDATE.REQUEST,
  LIS.BLOCK.UPDATE.SUCCESS,
  LIS.BLOCK.UPDATE.ERROR,
  (args: UpdateBlockArgs) => `blocks/${args.id}`,
  ApiService.partialUpdateAdminBlock
) as AsyncSagaAction<UpdateBlockArgs>;

type CreateBlockArgs = Parameters<typeof ApiService.createBlock>[0];
export const createBlock = createAsyncSaga(
  LIS.BLOCK.CREATE.REQUEST,
  LIS.BLOCK.CREATE.SUCCESS,
  LIS.BLOCK.CREATE.ERROR,
  (args: CreateBlockArgs) =>
    `specimens/${args.requestBody?.specimen_id}/blocks/create`,
  ApiService.createBlock
) as AsyncSagaAction<CreateBlockArgs>;

type DestroyBlockArgs = Parameters<typeof ApiService.destroyBlock>[0] & {
  caseId: number;
};
export const destroyBlock = createAsyncSaga(
  LIS.BLOCK.DESTROY.REQUEST,
  LIS.BLOCK.DESTROY.SUCCESS,
  LIS.BLOCK.DESTROY.ERROR,
  (args: DestroyBlockArgs) => `blocks/${args.id}/destroy`,
  ApiService.destroyBlock
) as AsyncSagaAction<DestroyBlockArgs>;
